import React, { Component } from 'react'

class Screen4 extends Component {

  render() {

      const { entry, addEntry, language, t } = this.props

      return (
      <main>
        <h3>{entry.form}</h3>
        <div>
          <p>{t(language, 'descriptionHint')}</p>
          <label>{t(language, 'titleField')}
            <input type="text" value={entry.title} onChange={(e) => addEntry('title', null, e)} />
          </label>
          <label>{t(language, 'descriptionField')}
            <textarea onChange={(e) => addEntry('description', null, e)}>{entry.description}</textarea>
          </label>
        </div>
      </main>
    );
  }
}

export default Screen4;
